import { getDicomNodeConfig, patchDicomNodeConfig } from '@api/dicomnode';
import useAuth from '@hooks/Auth/useAuth';
import { usePermissionMutation } from '@hooks/Permission/usePermissionMutation';
import useModalActions from '@hooks/common/useModalAction';
import {
  DicomNodeConfigRequest,
  DicomNodeConfigRequestBody,
  DicomNodeConfigResponse,
} from '@models/DicomNode';
import { APIError } from '@models/index';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export default function useGetDicomNodeConfig() {
  const { accessToken } = useAuth();

  const query = useQuery<DicomNodeConfigResponse>({
    queryKey: ['DicomNodeConfig'],
    queryFn: async () => {
      try {
        const res = await getDicomNodeConfig({ accessToken });
        if (!(res.status === 200 || res.status === 201)){
          console.log('Axios Error', res.status);
        }
        return res.data;
      } catch (error) {
        throw error;
      }
    },
    refetchOnWindowFocus: true,
    staleTime: 0,
  });

  return query;
}

export function usePatchDicomNodeConfig() {
  const { accessToken } = useAuth();
  const queryClient = useQueryClient();
  const { errorAction } = useModalActions();

  return usePermissionMutation<void, DicomNodeConfigRequestBody>({
    mutationFn: async (params: DicomNodeConfigRequestBody) => {
      try {
        await patchDicomNodeConfig({ accessToken, params });
      } catch (err) {
        throw err;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['DicomNodeConfig'] });
    },
    onError: (error) => {
      console.log('error: ', error);
      errorAction(
        error as APIError,
        'Failed. Please contact the administrator.',
      );
    },
  });
}
